var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_1055_14584)",
    style: {}
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1055_14584",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1055_14584",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1055_14584",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD8ElEQVR4nO2dz48URRTHJyZGTDQxgbsx8g9IokeQBBVBxF8L/V5DVtep10TCgRu3uZid9waJ8ahHPaoXuHLHg5pw8GCiJBzQ+CPRk+AiaJqdCAu987N6+m3195N05jL75tV85lVX1c5UdToAAAAAaBQq9DkOdo5FL1Ow3znoDRK7ysHOs5gsvdd7rNkMW8Kx7tmnSPQCi/076qKgv1DQoul8k4aC7WHR38bJ2CBG9NP9pz56pOnckyOXwYskdn0aGf9fwT5rOv+kWF7+8AkS/WMmGXcvabodSZHPUyHDe8rKij3edDuSIpPB/nmkcHfwdtNtSI5sLin6RdP5b0lI+odY9AcK+l1e9J+PKOX7Zlq0hckLfYtE1+4ZIf1Y9bwZpfy5+BalJEPudDPXNnv+9FI2jwUmkEHBbrEod0YwnRT9alQsMITC4M2KyrjNYic6cYfE708Sr9VQhYyyMvJgK9PEGV8pejs70X+mvpYkAIu+MU9lTFMpFOzL+C1ICIpUGRNWyq+8cvbJeNm3oDIogowqKeuP/d0x4iYJR+6mRnVf5byDu/ZKzLhJwTVXRtUqcR1xk4BrkpF19Ui5zMLBvs3FdsXLOGG4Jhnl369PHocxxS7FyzpReEEyhveiy/EyT5C8O3h9YTKC3aTCDsTLPjG4ptEUib5TURn/ZIVRvOwTIxM9WH5PCjIckEGGHzLI8EMGGX7IIKO9MihoFi/7xMggww9U2AFUhhMIMtopg0TXyuWXeNknBkGGHwgy/ECQ4QeCDD8QZPiBg76M0ZQTGDLaK4PEXouXfWIwZPiBIcMPDBl+YMjwA0OGHyDDmYwHf9SiNf3b1f7G0BYytgaoDEdU//ZO0U1BRstZdGVw0T8cL/vEgAxHQIYjIMMRkOEIyHAEZDgCMhwBGS2WkQd7NV72iUFdfQkynAAZjoAMR0CGIyDDEZDhCMhwBGQ4onpTYEz6GgEyHMFie++vjPq2xdMb2BZvBL1e76E7p1VChg/ysPrs4r431T8UL/NEIdEz93cp5YrurPHQTc0JBb1YcdTCTJ9mVMacLC/3tnHQvzY5kGQqKZARbzf/Ucf1TCQFMiJBYjZGyFgpkBEREv1mAiGbSoGMiBw/ubq9Ymg6sRTIiAyLHZ1CxgYpkFEDJPbJDELWlz4e2K7Crs8zdwHrXc6VmYREmrOAezj27urOWDJwAFYEKGgxr4zhguTeGPm0Hgr2+fT3DrvJYl9zUOUw2Cfy8cOtfyNjwUF/HlsBwW6V85Ry8pgV+sLS6XOPRksAbKQ8wL26G9Ir5eirPBaO5IMdeN8WRPmJL6WQ2E9l91XeU47K4OlFvT4AAAAAOjPxH05qIFzMf6yZAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.04297fb9422215eb1e008154ca6ff6b9.svg";
export { ForwardRef as ReactComponent };